import { TApplicationState } from '../../types/redux';
import { selectFilters } from './selectFilters';

export const selectSuburbanFormValues = (state: TApplicationState) => {
  const filters = selectFilters(state);

  return {
    category: filters.category,
    address: filters.address,
    houseArea: filters.houseArea,
    landArea: filters.landArea,
  };
};
